<div class="image-preview-dialog">
  <div class="image-preview-dialog__close-btn" (click)="close()" cdkFocusRegionstart>
    <span class="material-icons">close</span>
  </div>

  <div *ngIf="imageData"
       class="image-preview-dialog__image">
    <img [src]="imageData" alt="">
  </div>
</div>
